if (!customElements.get('section-5050')) {
    customElements.define('section-5050', class Section5050 extends HTMLElement {
        constructor() {
            super();
        }
    
        connectedCallback() {            
            this.handleVideoPlay();
        }

        handleVideoPlay() {
            // Select the play button and video elements within this custom element
            const playButton = this.querySelector('.section-5050__video-play');
            const video1 = this.querySelector('.section-5050__media-single video');
            const video = this.querySelector('.section-5050__media-single');
        
            if (playButton && video) {      
                // Add an event listener to the video element to toggle play/pause, remove it after the first click
                video.addEventListener('click', () => {
                    if (video1.paused) {                
                        video1.play();
                        video1.controls = true;
                        playButton.style.display = "none";
                    } else {
                        video1.pause();
                    }
                }, { once: true });
            }
            }
    });
  };